<script lang="ts">
  import LayoutGrid, { Cell } from '@smui/layout-grid';
  import { onMount } from 'svelte';
  import { getAppConfig } from '../../../../common/config/app-config';
  import Icon from '../../../common/components/Icon.svelte';
  import Text from '../../../common/components/Text.svelte';
  import { fetchMultipleDataFromAmplienceAsync } from '../../../common/services/amplience';
  import VDivider from '../../../product-details/components/VDivider.svelte';
  import { blogArrowClicked } from '../../services/blog-data-services';

  export let prePost: any;
  export let nextPost: any;
  let prevTitle;
  let nextTitle;
  const { lang } = getAppConfig();

  onMount(async () => {
    return fetchMultipleDataFromAmplienceAsync([prePost, nextPost]).then((data: any) => {
      prevTitle = data?.responses?.filter(x => x?.content?._meta?.deliveryKey === prePost)[0]?.content?.title;
      nextTitle = data?.responses?.filter(x => x?.content?._meta?.deliveryKey === nextPost)[0]?.content?.title;
    });
  });
</script>

<section class="blog-detail-prev-next-container">
  <LayoutGrid>
    <Cell class="blog-detail-prev-container" spanDevices={{ desktop: 5, tablet: 4, phone: 1 }}>
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="blog-detail-prev-icon" on:click={() => blogArrowClicked(prePost)}>
        <Icon type="font" glyph={lang === 'en' ? 'chevron_left' : 'chevron_right'} mobileSize={40} desktopSize={90} />
      </div>
      <div class="blog-detail-prev-text">
        <span>
          <Text key="extra.ampliance.blog.previousArticle" />
        </span>
        <h5>{prevTitle ? prevTitle : prePost.replace(/-/g, ' ')}</h5>
      </div>
    </Cell>
    <VDivider width="2" />
    <Cell class="blog-detail-next-container" spanDevices={{ desktop: 5, tablet: 4, phone: 1 }}>
      <div class="blog-detail-next-text">
        <span>
          <Text key="extra.ampliance.blog.nextArticle" />
        </span>
        <h5>{nextTitle ? nextTitle : nextPost.replace(/-/g, ' ')}</h5>
      </div>
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="blog-detail-next-icon" on:click={() => blogArrowClicked(nextPost)}>
        <Icon type="font" glyph={lang === 'en' ? 'chevron_right' : 'chevron_left'} mobileSize={40} desktopSize={90} />
      </div>
    </Cell>
  </LayoutGrid>
</section>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .blog-detail-prev-next-container {
    background: rgba(241, 241, 241, 0.3);
    padding: 70px 0;
    margin-bottom: -60px;
    @include desktop-max-width {
      padding: 30px 12px;
      margin-bottom: 0;
    }
    :global {
      .mdc-layout-grid {
        padding: 0;
        max-width: 1440px;
        margin-inline: auto;
      }
      .mdc-layout-grid__inner {
        gap: 13px;
        justify-content: space-between;
        display: flex;
      }
      .blog-detail-prev-container,
      .blog-detail-next-container {
        display: flex;
        align-items: center;
        gap: 40px;
        @include desktop-max-width {
          gap: 10px;
        }
      }
    }
    .blog-detail-prev-icon,
    .blog-detail-next-icon {
      color: rgba(0, 101, 164, 1);
      cursor: pointer;
    }
    .blog-detail-next-text {
      text-align: right;
    }
    .blog-detail-prev-text,
    .blog-detail-next-text {
      font-size: 20px;
      font-weight: 400;
      line-height: 30px;
      color: $neutral-dark-01;
      @include desktop-max-width {
        font-size: 12px;
        line-height: 20px;
        max-width: 110px;
        word-wrap: break-word;
      }
      h5 {
        text-transform: capitalize;
        font-size: 26px;
        font-weight: 700;
        line-height: 32px;
        margin: 0;
        @include desktop-max-width {
          font-size: 14px;
          line-height: 18px;
        }
      }
    }
  }
</style>
